export default "__VITE_PUBLIC_ASSET__cba21394__"